import {
  getAuthorStories,
  getMyStoryAuthorOptions,
  getStoryTray,
  getStoryViewers,
} from "@/actions/story";
import { getHighlightItems, getHighlights } from "@/actions/story-highlight";
import type { StoryAuthorType } from "@/db/schema/story";

/** Thin client wrappers that unwrap ActionResult into throw-on-error data. */
export const storyQueryFns = {
  tray: async () => {
    const result = await getStoryTray();
    if (!result.ok) throw new Error(result.message);
    return result.data;
  },
  myAuthorOptions: async () => {
    const result = await getMyStoryAuthorOptions();
    if (!result.ok) throw new Error(result.message);
    return result.data;
  },
  author: async (authorType: StoryAuthorType, authorId: string) => {
    const result = await getAuthorStories({ authorType, authorId });
    if (!result.ok) throw new Error(result.message);
    return result.data;
  },
  viewers: async (storyId: number, cursor?: number | null) => {
    const result = await getStoryViewers({ storyId, cursor });
    if (!result.ok) throw new Error(result.message);
    return result.data;
  },
  highlights: async (ownerType: StoryAuthorType, ownerId: string) => {
    const result = await getHighlights({ ownerType, ownerId });
    if (!result.ok) throw new Error(result.message);
    return result.data;
  },
  highlightItems: async (highlightId: number) => {
    const result = await getHighlightItems(highlightId);
    if (!result.ok) throw new Error(result.message);
    return result.data;
  },
};
